import { useRef } from 'react'

import { useDrawBox } from '../hooks/useDrawBox'
import { useTailgateGrid } from '../hooks/useTailgateGrid'

import { Container } from '../styles/styles'
import { BoxType, CornerPoint } from '../types/types'
import { updateTailgateBox } from '../utils/utils'

export type TailgateGridProps = {
  width: number
  height: number
}

export const TailgateGrid = ({ width, height }: TailgateGridProps) => {
  const svgRef = useRef(null)

  const onDataDragged = (d: CornerPoint) => {
    if (d.type === BoxType.IN_BOX) {
      setInBox((box) => updateTailgateBox(box, d, scaleX, scaleY))
    } else {
      setOutBox((box) => updateTailgateBox(box, d, scaleX, scaleY))
    }
  }

  const { outBox, setOutBox, inBox, setInBox, handleOnClick, scaleX, scaleY } =
    useTailgateGrid()

  useDrawBox({
    inBox: inBox,
    outBox: outBox,
    onDeviceUpdated: onDataDragged,
    frame: { width, height },
    svgRef,
  })

  return (
    <div
      style={{
        position: 'absolute',
        zIndex: 1,
        top: 0,
        bottom: 0,
      }}
    >
      <Container>
        <svg
          height={height}
          id='tailgateGrid'
          onClick={handleOnClick}
          ref={svgRef}
          width={width}
        >
          <g className='outBox-line-group' />
          <g className='outBox-corner-group' />

          <g className='inBox-line-group' />
          <g className='inBox-corner-group' />
        </svg>
      </Container>
    </div>
  )
}
